<template>
    <div class="card">
        <div class="card-body">
            <h4 class="card-title">
                {{ title }}
                <button v-if="editable" class="btn btn-primary btn--icon-text btn-list--create float-right" @click="createNewRecord()">
                    <i class="zmdi zmdi-plus"></i> {{ createRecordLabel }}
                </button>
            </h4>

            <div class="text-center" v-if="!ready"><i class="zmdi zmdi-refresh zmdi-hc-fw rotating text-gray home-loader"></i></div>

            <div class="scrollbar-inner">
                <div v-if="ready">
                    <div class="text-center list--empty" v-if="isListEmpty">
                        <img src="@/assets/img/emptyListAvatar.png" alt="">
                        <h6 class="m-3 text-muted">{{ $t('LBL_EMPTY_LIST') }}</h6>
                    </div>
                    <table v-else class="table table-sm table-hover mb-0">
                        <thead>
                        <tr>
                            <th v-for="header in headers" nowrap>
                                {{ header.label }}
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr class="cu-pointer" v-for="entry in getEntries" :data-id="entry.record_id" @click="detailView(entry.record_id)">
                            <td v-for="field in entry">
                                <component :is="getValueComponent(field)" v-bind="field"></component>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div ref="modalContainer"></div>
        </div>
    </div>
</template>

<script>
    import QuickCreateForm from '@/components/QuickCreateForm'
    import BaseValue from '@/components/list_elements/Base'
    import TicketStatusValue from '@/components/list_elements/TicketStatus'

    export default {
        data() {
            return {
                ready: false
            }
        },

        props: {
            fields: {default: function () { return [] }},
            headers: {default: function () { return [] }},
            entries: {default: function () { return [] }},
            creationFields: {default: function() {return []}},
            title: {default: ''},
        },

        components: {
            'form-quickcreate': QuickCreateForm,
            'base-value': BaseValue,
            'ticketstatus-value': TicketStatusValue
        },

        computed: {
            isListEmpty() {
                if(Object.keys(this.entries).length > 0){
                    return false
                }

                return true
            },

            editable() {
                let moduleStructure = this.$store.state.structure.modules[this.module]

                if(!AppHelper.empty(moduleStructure) && moduleStructure.editable){
                    return true
                }

                return false
            },

            createRecordLabel() {
                return this.$t('LBL_CREATE')
                    + ' ' + this.$store.state.structure.modules[this.module].singleLabel
            },

            getEntries() {
                let fields = this.$store.getters.getFields(this.module)

                for(let key in this.entries){
                    let entry = this.entries[key]

                    for(let key in entry){
                        let field = $.extend({}, fields[key])
                        if(AppHelper.empty(field)){
                            continue
                        }
                        entry[key] = Object.assign(field, entry[key])
                    }

                    this.entries[key] = entry
                }

                return this.entries
            }
        },

        watch: {
            entries() {
                this.ready = true
            }
        },
        methods: {
            detailView(record) {
                this.$router.push({ name: 'Detail', params: {view: 'DetailView', module: this.module, record: record}})
            },

            getValueComponent(field){
                if(!AppHelper.empty(field) && field.name == 'ticketstatus'){
                    return 'ticketstatus-value'
                }
                else{
                    return 'base-value'
                }
            },

            async createNewRecord() {
                let quickCreateForm = this.getComponentInstance(QuickCreateForm, {
                    propsData: {
                        mainFields:  this.$store.getters.getQuickCreateFields(this.module),
                        title: this.createRecordLabel,
                        submitButtonLabel: this.$t('LBL_SUBMIT_TICKET'),
                        module: this.module
                    }
                })

                quickCreateForm.$mount()
                this.$refs.modalContainer.appendChild(quickCreateForm.$el)
            }
        }
    }
</script><style lang="scss">@import "@/assets/scss/components/_list.scss";</style>